import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { getWhatsAppLink } from "@/data/sample-listings";
import { trackWhatsAppClick } from "@/lib/analytics";

interface WhatsAppButtonProps {
  message: string;
  variant?: 'default' | 'floating' | 'inline';
  label?: string;
  className?: string;
  listingId?: string;
  category?: string;
}

export const WhatsAppButton = ({ 
  message, 
  variant = 'default', 
  label = 'Book via WhatsApp',
  className = '',
  listingId,
  category,
}: WhatsAppButtonProps) => {
  const link = getWhatsAppLink(message);

  const handleClick = () => {
    trackWhatsAppClick(listingId, category);
  };

  if (variant === 'floating') {
    return (
      <motion.a
        href={link}
        onClick={handleClick}
        target="_blank"
        rel="noopener noreferrer"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 1, type: "spring" }}
        className={`fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform ${className}`}
        style={{ 
          background: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)',
          boxShadow: '0 4px 20px rgba(37, 211, 102, 0.4)'
        }}
      >
        <MessageCircle className="w-6 h-6 text-white" />
        
        {/* Pulse animation */}
        <span className="absolute inset-0 rounded-full animate-ping opacity-30" 
          style={{ background: '#25D366' }} 
        />
      </motion.a>
    );
  }

  if (variant === 'inline') {
    return (
      <a
        href={link}
        onClick={handleClick}
        target="_blank"
        rel="noopener noreferrer"
        className={`inline-flex items-center gap-2 text-whatsapp hover:text-whatsapp-dark font-medium transition-colors ${className}`}
      >
        <MessageCircle className="w-5 h-5" />
        {label}
      </a>
    );
  }

  return (
    <a
      href={link}
      onClick={handleClick}
      target="_blank"
      rel="noopener noreferrer"
      className={`whatsapp-btn ${className}`}
    >
      <MessageCircle className="w-5 h-5" />
      {label}
    </a>
  );
};
